<template>
<Sky />
<!-- <span style="color: #fff">{{JSON.stringify(suggestions)}}</span> -->
<div class="home" @click="showSuggestions = false">
    <!-- <span style="color: #fff">{{JSON.stringify(info)}}</span> -->
    <!-- <span style="color: #fff">{{query}}--</span> -->
    <div class="input-box" @click.stop="focusFn">
        <div class="tip" v-if="error && error.type">
            <img src="@/assets/error.png" class="tip-icon" alt="" v-if="error.type == 'error'" />
            <img src="@/assets/warn.png" class="tip-icon" alt="" v-if="error.type == 'warn'" />
            {{error.msg}}
            <div class="tip-arrow"></div>
        </div>
        <input 
            type="text" 
            ref="inputRef" 
            v-model="query" 
            class="search-input" 
            maxlength="64" 
            
            @keyup.enter="search()" 
        />
        <span v-if="!query" class="placehold" @click="toFocus">请输入哈希值</span>
        <img src="@/assets/search.png" alt=""  class="search-icon" :class="{fix: query}" @click.stop="search()">
        <div class="suggestion-box" :class="{ani: showSuggestions && suggestions.length}">
            <div v-for="item in suggestions" :key="item" class="suggestion-item" @click.stop="chooseSuggestion(item)">
                {{item}}
            </div>
        </div>
    </div>
    <div class="chain-box">
        <div class="item">
            <span class="num">{{info.height}}</span>
            <span class="label">区块高度</span>
        </div>
        <div class="item">
            <span class="num">{{info.transactionTotalNum}}</span>
            <span class="label">交易总量</span>
        </div>
        <!-- <div class="item">
            <span class="num">{{info.accountTotalNum}}</span>
            <span class="label">账户总数</span>
        </div>
        <div class="item">
            <span class="num">{{info.contractTotalNum }}</span>
            <span class="label">合约总数</span>
        </div>
        <div class="item">
            <span class="num">{{info.digitalAssetsTotalAmount }}</span>
            <span class="label">数字资产数</span>
        </div> -->
    </div>
</div>
</template>
<script>
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import Sky from '../components/Sky.vue'
import { getChainStatistic, getDetail } from '@/api/index'
import { onActivated, onBeforeMount, onMounted, reactive, ref, toRefs } from '@vue/runtime-core'
import router from '@/router'

export default {
    components: { Sky },
    name: 'Home',
    setup() {
        const state = reactive({
            query: '',
            info: {
                height: 0,
                transactionTotalNum: 0,
                accountTotalNum: 0,
                contractTotalNum: 0,
                digitalAssetsTotalAmount: 0
            },
            error: {},
            inputRef: null,
            showSuggestions: false,
            suggestions: localStorage.getItem('querys') ? JSON.parse(localStorage.getItem('querys')) : []
        })

        const socket = new SockJS('/ws/browser')
        const stompClient = Stomp.over(socket)

        const subscribe = () => {
            stompClient.subscribe('/chain/statistic', (response) => {
                const table = JSON.parse(response.body).data
                state.info.height = table.height
                state.info.transactionTotalNum = table.transactionTotalNum
                state.info.accountTotalNum = table.accountTotalNum
                state.info.contractTotalNum = table.contractTotalNum
                state.info.digitalAssetsTotalAmount = table.digitalAssetsTotalAmount
                // console.warn('区块链高度')
                // console.warn('table-----', state.info)

                // this.$store.dispatch('setBlockHeight', table)
            }, ()=>{
                console.warn('2222')
            })
        }

        const connect =()=>{
            stompClient.connect({}, ()=>{
                console.log('ws:连接ws成功')
                subscribe()
            })
        }
        const init = () => {
            getChainStatistic().then(({data})=>{
                const table = data
                state.info.height = table.height
                state.info.transactionTotalNum = table.transactionTotalNum
                state.info.accountTotalNum = table.accountTotalNum
                state.info.contractTotalNum = table.contractTotalNum
                state.info.digitalAssetsTotalAmount = table.digitalAssetsTotalAmount
            })
            connect()
        }

        onBeforeMount(init)

        function saveLocal(){
            const maxLen = 2
            const querys = state.suggestions
            const queryIndex = querys.indexOf(state.query)
            if(queryIndex>=0){
                querys.unshift(state.query);
                querys.splice(queryIndex+1, 1)
            }else{
                querys.unshift(state.query);
                querys.length > maxLen && querys.splice(querys.length-1, 1)
            }
            localStorage.setItem('querys', JSON.stringify(querys))
            state.suggestions = querys
        }

        const toFocus = () => {
            state.inputRef?.focus()
        }

        let searching = false    
        const search = () => {
            // debugger
            
            if(!state.query){
                console.warn(state.inputRef)
                toFocus()
                return
            }
            
            // hash格式(数字+小写字母+长度64位）
            const reg = /^[0-9a-z]{64}$/
            if(!reg.test(state.query)){
                // state.error = {}
                state.error.type = 'error'
                state.error.msg = '请输入正确的哈希值'
                return
            }
            if(searching){
                console.log('搜索频率太快')
                return
            }
            searching = true 

            getDetail({
                hash: state.query
            }).then(({data})=>{
                console.log('data', data)
                router.push({
                    name: 'Detail',
                    query: {
                        hash: state.query
                    },
                    params: data
                })
                searching = false
                // 只记录成功搜索过的
                saveLocal()
            }).catch((res)=>{
                console.warn(res)
                state.error.type = res.code == 'M20054' ? 'warn' : 'error'
                state.error.msg = res.msg || '网络故障，请重试'
                searching = false
            })
        }

        const focusFn = () => {
            state.showSuggestions = true
            state.error = {}
        }
        const blurFn = () => {
            setTimeout(()=>{
                state.showSuggestions = false
            }, 200)
        }

        const chooseSuggestion = (item)=>{
            state.query = item
            state.inputRef.focus()
            
        }

        onMounted(()=>{
            document.body.addEventListener('click', ()=>{
                state.showSuggestions = false
            })
        })

        onActivated(()=>{
            state.query = ''
        })


        return {
            ...toRefs(state),
            search,
            focusFn,
            blurFn,
            toFocus,
            chooseSuggestion,
        }
    },
}
</script>


<style scoped>
@font-face {
    font-family: "akrobat";
    src:url('~@/assets/Akrobat-ExtraBold.ttf');
}

.home{
    /* position: relative; */
    
    margin: 0 auto 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.input-box{
    width: 960rem;
    position: relative;
    margin-top: 40rem;
    height: 72rem;
}
.input-box .search-icon{
    position: absolute;
    width: 30rem;
    top: 21rem;
    left: 0;
    transform: translateX(410rem);
    /* transition: transform 200ms; */
    /* left: 410rem; */
}
.input-box .search-icon.fix, .search-input:focus+.placehold+.search-icon{
    /* right: 25.6rem; */
    transform: translateX(906.4rem);
    /* transition: transform 200ms; */
    cursor: pointer;
}

.input-box .tip{
    position: absolute;
    top: -56rem;
    left: 50%;
    transform: translateX(-50%);
    background: #1F2235;
    border-radius: 20rem;
    line-height: 26.4rem;
    font-size: 17.6rem;
    padding: 7.2rem 19.2rem;
    color: #B6B6B6;
}
.input-box .tip .tip-icon{
    width: 19.2rem;
    height: 19.2rem;
    margin-right: 8rem;
    vertical-align: middle;
}
.input-box .tip .tip-arrow{
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 6px;
    left: 50%;
    bottom: -5px;
    margin-left: -3px;
    background: #1F2235;
    transform: rotate(45deg);
}

.search-input{
    width: 100%;
    height: 71rem;
    font-size: 22.4rem;
    border: none;
    background: #1F2235;
    border-radius: 36rem;
    line-height: 36rem;
    color: #fff;
    padding: 0 36rem;
    box-sizing: border-box;
}
.search-input:focus{
    outline: none;
}
/* .search-input::-webkit-input-placeholder{
    color: #515362;
    padding-left: 411rem;
} */
.placehold{
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    color: #515362;
    padding-left: 447rem;
    line-height: 71rem;
}
.search-input:focus+.placehold{
    display: none;
}
.suggestion-box{
    /* position: absolute;
    width: 100%;
    top: 0;
    left: 0; */
    background: #15172B;
    margin-top: -36rem;
    padding-top: 36rem;
    border-radius: 0 0 36rem 36rem;
    overflow: hidden;
    height: 0;
    transition: height 200ms;
    
}
.suggestion-box.ani{
    height: calc(91rem * v-bind('suggestions.length'));
    transition: height 200ms;
}
.suggestion-item{
    cursor: pointer;
    box-sizing: border-box;
    color: #6A6C78;
    border-bottom: solid 1px #262942;
    margin: 0 40rem;
    font-size: 20.8rem;
    height: 91rem;
    line-height: 91rem;
    overflow: hidden;
    position: relative;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.suggestion-item:hover{
    color: #fff;
}
.suggestion-item:last-child{
    border: none;
}


.chain-box{
    margin-top: 28rem;
    display: flex;
    min-width: 960rem;
}
.chain-box .item{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 35.2rem 10px;
}
.chain-box .item .num{
    font-family: akrobat;
    font-weight: 800;
    font-size: 38.4rem;
    line-height: 57.6rem;
    color: #fff;
}
.chain-box .item .label{
    font-size: 17.6rem;
    line-height: 26.4rem;
    margin-top: 3.2rem;
    color: #6A6C78;
}
</style>
